<template>
  <div></div>
</template>

<script>
export default {
  name: 'Constant'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Constant.vue